import { Component, Input, OnInit } from '@angular/core';
import { ControlContainer, FormGroup, FormGroupDirective, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AppSettings } from 'app/modules/shared/app.settings';
import type { Language } from 'app/modules/shared/models/language';
import { MetaDataService } from 'app/modules/shared/services/meta-data.service';
import { InputNumberModule } from 'primeng/inputnumber';
import { CommonBindingDataService } from '../../../services/common-binding-data.service';

@Component({
  selector: 'app-mi-input-width-height-length',
  templateUrl: './mi-input-width-height-length.component.html',
  styleUrls: ['./mi-input-width-height-length.component.scss'],
  standalone: true,
  imports: [FormsModule, ReactiveFormsModule, InputNumberModule]
})

export class MiInputWidthHeightLengthComponent implements OnInit {
  @Input() field: any;
  formName: FormGroup;
  @Input() attributeLabels: [];
  @Input() moduleName: string;
  unit: string;
  language: Language;
  languageCode: string;
  placeholder: any;

  constructor(private formGroupDirective: FormGroupDirective,
    public controlContainer: ControlContainer, private metaDataService: MetaDataService,
    public cs: CommonBindingDataService) {
    this.formName = this.formGroupDirective.control;
    this.language = JSON.parse(localStorage.getItem(AppSettings.LANGUAGE));
    this.languageCode = this.language[0].langCode;
  }

  ngOnInit(): void {
    if (this.language && this.languageCode) {
      if (this.field) {
        const unit = this.metaDataService.systemOfMeasurement;
        const tempUnit = unit === 'Imperial' ? JSON.parse(this.field?.imperialUnit) : JSON.parse(this.field?.metricUnit);
        this.languageCode = this.language[0].langCode;
        this.unit = tempUnit[this.languageCode];
      }
    }

    this.placeholder = this.cs.getLabelValue(`${this.moduleName}.fields.${this.field.attributeCode}.placeholder`, this.attributeLabels, null);
    this.placeholder = this.placeholder === null ? '' : this.placeholder;
  }

}
